import { useEffect } from 'react';

const DEFAULT_TITLE = "Aurora - Pixxel's EO Studio";

interface PageTitleProps {
  title?: string;
  resourceType?: 'AOI' | 'Workflow' | 'Marketplace' | 'Order desk';
}

export default function PageTitle({ title, resourceType }: PageTitleProps) {
  const fullTitle =
    title && resourceType
      ? `${title} - ${resourceType} | ${DEFAULT_TITLE}`
      : title
        ? `${title} | ${DEFAULT_TITLE}`
        : DEFAULT_TITLE;

  useEffect(() => {
    document.title = fullTitle;
  }, [fullTitle]);
  return null;
}
